import React from 'react';
import './AirportHeightClearanceNOC.css'; // Create a CSS file for Airport Height Clearance NOC specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_airport_clearance_banner from '../../assets/images/airport-1.jpg'; // Replace with the actual image for Airport Height Clearance NOC
import { FaPlane, FaGavel, FaCertificate, FaMapMarkerAlt, FaClipboardList } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function AirportHeightClearanceNOC() {
  const airportNocBenefits = [
    {
      icon: <FaPlane />,
      title: 'Aviation Safety',
      text: 'Ensure the safety of flight operations by complying with height clearance regulations around airports.',
    },
    {
      icon: <FaCertificate />,
      title: 'Legal Compliance',
      text: 'Comply with the regulations set by the Airport Authority of India (AAI) to avoid legal issues.',
    },
    {
      icon: <FaGavel />,
      title: 'Avoid Penalties',
      text: 'Obtain the required clearance to avoid fines or penalties for non-compliance.',
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Safe Construction',
      text: 'Ensure safe construction of buildings, towers, or structures near airport zones with proper height clearance.',
    },
  ];

  const steps = [
    {
      icon: <FaClipboardList />,
      title: 'Initial Consultation',
      description: 'Discuss your project and determine if height clearance is required for the location.',
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Site Evaluation',
      description: 'Evaluate the site and review aerial maps to ensure that height clearance requirements are met.',
    },
    {
      icon: <FaCertificate />,
      title: 'Document Preparation',
      description: 'Prepare the necessary documents and site plans to support the NOC application.',
    },
    {
      icon: <FaPlane />,
      title: 'Application Submission',
      description: 'Submit the application for height clearance to the Airport Authority of India (AAI).',
    },
    {
      icon: <FaGavel />,
      title: 'Height Clearance Issuance',
      description: 'Receive the height clearance NOC from AAI to proceed with the construction project.',
    },
  ];

  const acts = [
    'Aircraft Act, 1934',
    'Indian Aircraft Rules, 1937',
    'Aviation Safety and Navigation Regulations',
  ];

  const explanation =
    'The Airport Authority of India (AAI) mandates that structures built in the vicinity of airports must comply with specified height limitations to ensure the safety of air traffic. Obtaining a height clearance NOC from AAI is essential for construction projects near airport zones to prevent interference with aviation operations.';

  const checklistItems = [
    { name: 'Site Plan and Layout', description: 'Submit the layout and location map of the proposed structure.' },
    { name: 'Aerial Map', description: 'Provide an aerial map of the surrounding area for the proposed construction.' },
    { name: 'Structural Details', description: 'Include the structural design details, including the proposed height of the structure.' },
    { name: 'NOC from Local Authorities', description: 'Attach a copy of the NOC from local authorities if applicable.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Airport Authority of India Height Clearance NOC"
        subheading="Ensure your construction complies with height regulations near airports with expert guidance and NOC assistance."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/airport-height-clearance-noc' }}
        backgroundImage={img_airport_clearance_banner} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is Airport Height Clearance NOC?"
        description="The Airport Authority of India (AAI) Height Clearance NOC is required for any construction within the vicinity of airports. This clearance ensures that the proposed structure does not pose a risk to aviation safety."
        image={img_airport_clearance_banner} // Image for Airport Height Clearance NOC process
        altText="Airport Height Clearance NOC Process"
      />

      <ServicesBenefitsSection
        title="Why You Need Airport Height Clearance NOC"
        description="Learn the importance of obtaining height clearance for safe and compliant construction near airports."
        benefits={airportNocBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Aviation Safety and Construction Regulations"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple Airport Height Clearance Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Airport Height Clearance NOC Onboarding Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
